import React, { useState, useEffect } from "react"
import CustomTextField from '../../StandardComponents/CustomTextField';
import useWindowDimensions from '../../util/useWindowDimensions';
import SignatureApp from './SignatureApp';

import ReactDOM from 'react-dom'
import SignatureCanvas from 'react-signature-canvas'

import BasicDatePicker from '../../StandardComponents/BasicDatePicker';

import {CONST_ERROR, CONST_SUCCESS, CONST_DETAILS} from '../../../constants/string'
import * as database from '../../../constants/database'
import * as localstorage from '../../../constants/localstorage'


import { makeStyles } from '@material-ui/core/styles';
import { db } from "../../../firebase"
import { useAuth } from "../../../contexts/AuthContext"

import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';


import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';

import { Typography } from "@material-ui/core";
import GeneralViewContainer from "../../StandardComponents/GeneralViewContainer";

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
  fab: {
    position: 'absolute',
    bottom: theme.spacing(3),
    right: theme.spacing(3),
  },
  snack: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
  progressbar: {
    position: 'absolute',
    zIndex : '1000',
    width: '10%',
    height: '100%',
  },
  signatureBoxInner:{
    backgroundColor: "purple"
  }

  
}));



function notEmpty(val){
  if(val)
  {
    return true;
  }
  return false;
}



var invoiceNumberBefore = "";
var invoiceNumberLive = "";

var invoiceDateCreatedBefore = "";
var invoiceDateCreatedLive = "";

var invoiceTermsBefore = "";
var invoiceTermsLive = "";

var invoiceDueDateBefore = "";
var invoiceDueDateLive = "";

var invoicePONumberBefore = "";
var invoicePONumberLive = "";



export default function Signature (props) {

  const { currentUser } = useAuth()

  var userRef = db.collection("users").doc(currentUser.uid);
  var documentsRecordsRef = userRef.collection(database.TABLE_NAME_INVOICES);

  const { height, width } = useWindowDimensions();

  var specificItemRef;

  function setQuery(){

    var docId = localStorage.getItem(localstorage.CONST_LOCALSTORAGE_DOCUMENTID);
    if(!docId)
    {
       props.startSnackBar(true, 20000,"No Contact Provided","error",true)
        return;
    }
    specificItemRef = documentsRecordsRef.doc(docId);
    
  }


  var [loading, setLoading] = useState(false)


  const [invoiceNumber, setInvoiceNumber] = useState("")

  const [invoiceDateCreated, setInvoiceDateCreated] = useState("")

  const [invoiceTerms, setInvoiceTerms] = useState("")

  const [invoiceDueDate, setInvoiceDueDate] = useState("")

  const [invoicePONumber, setInvoicePONumber] = useState("")


  const [open, setOpen] = React.useState(false);
  const openDialog = () => {
    setOpen(true);
  };

  const closeDialog = () => {
    setOpen(false);
  };



  async function writeUserData() {
    setLoading(true)
    return specificItemRef.set({
      [database.COLUMN_NAME_INVOICE_NUMBER]: invoiceNumber,
      [database.COLUMN_NAME_INVOICE_CREATEDDATE]: invoiceDateCreated,
      [database.COLUMN_NAME_INVOICE_TERMS]: invoiceTerms,
      [database.COLUMN_NAME_INVOICE_DUEDATE]: invoiceDueDate,
      [database.COLUMN_NAME_INVOICE_PONUMBER]: invoicePONumber,
    },{ merge: true })
    .then(() => {
      setLoading(false)
      setError("")

      
      props.setSaveState(false);

      props.startSnackBar(true, 2000,CONST_SUCCESS.SAVED,"success",true)

      invoiceNumberBefore = invoiceNumberLive
      invoiceDateCreatedBefore = invoiceDateCreatedLive
      invoiceTermsBefore = invoiceTermsLive
      invoiceDueDateBefore = invoiceDueDateLive
      invoicePONumberBefore = invoicePONumberLive

  })
  .catch((error) => {
      props.startSnackBar(true, 20000,CONST_ERROR.FAILED_TO_GET_DATA+" "+error.code,"error",true)

      setLoading(false)
  });
  }


 
  const fetchData=async()=>{
  return specificItemRef.get().then((doc) => {
    if (doc.exists) {

        var invoiceNumber = doc.data()[database.COLUMN_NAME_INVOICE_NUMBER]
        var invoiceCreatedDate = doc.data()[database.COLUMN_NAME_INVOICE_CREATEDDATE]
        var invoiceTerms = doc.data()[database.COLUMN_NAME_INVOICE_TERMS]
        var invoiceDueDate = doc.data()[database.COLUMN_NAME_INVOICE_DUEDATE]
        var invoicePoNumber = doc.data()[database.COLUMN_NAME_INVOICE_PONUMBER]

 
        if(invoiceNumber)
        {
          setInvoiceNumber(invoiceNumber);
          invoiceNumberBefore = invoiceNumber;
          invoiceNumberLive = invoiceNumber;
        }
        if(invoiceCreatedDate)
        {
          setInvoiceDateCreated(invoiceCreatedDate);
          invoiceDateCreatedBefore = invoiceCreatedDate;
          invoiceDateCreatedLive = invoiceCreatedDate;
        }
        if(invoiceTerms)
        {
          setInvoiceTerms(invoiceTerms);
          invoiceTermsBefore = invoiceTerms;
          invoiceTermsLive = invoiceTerms;
        }
        if(invoiceDueDate)
        {
          setInvoiceDueDate(invoiceDueDate);
          invoiceDueDateBefore = invoiceDueDate;
          invoiceDueDateLive = invoiceDueDate;
        }
        if(invoicePoNumber)
        {
          setInvoicePONumber(invoicePoNumber);
          invoicePONumberBefore = invoicePoNumber;
          invoicePONumberLive = invoicePoNumber;
        }

       

    } else {
      props.startSnackBar(true, 20000,CONST_ERROR.NO_SUCH_DATA,"error",true)

    }
}).catch((error) => {
  props.startSnackBar(true, 20000,CONST_ERROR.PROBLEM_GETTING_DATA+" "+error.code,"error",true)

});

}



useEffect(async () => {
  props.handleLoadingState(loading)
}, [loading])


useEffect(async () => {
  
  if(props.activateSave)
  {
    handleSaveData()
  }

}, [props.activateSave])


useEffect(async () => {
  // Update the document title using the browser API
  props.pageDisplayStatus((pageState) => ({...pageState, backButton:true, mainTab:false, invoiceEstimateTab:false, edPrHiTab: false}))

  setLoading(true)
  
try{
  setError("")
  setQuery()
  fetchData();
  props.setSaveState(false);
}
catch(error){
  props.startSnackBar(true, 20000,CONST_ERROR.FAILED_TO_GET_DATA+" "+error.code,"error",true)
}
  setLoading(false)
}, [])

  function checkForChanges(){

    if((invoiceNumberLive!==invoiceNumberBefore)||
    (invoiceDateCreatedLive!==invoiceDateCreatedBefore)||
    (invoiceTermsLive!==invoiceTermsBefore)||
    (invoiceDueDateLive!==invoiceDueDateBefore)||
    (invoicePONumberLive!==invoicePONumberBefore))
    {
      props.setSaveState(true);
    }
    else
    {
      props.setSaveState(false);
    }
  }


  const classes = useStyles();

  const [error, setError] = useState("")

  function handleSaveData(){
 
    setQuery()
    writeUserData()
 
  }


function enterKeyDown(val){
  if (val && props.currentSaveState) {
    handleSaveData();
    }
}

  const updateText = (e)=> {

    switch(e.target.id) {
      case "invoiceNumber":
        setInvoiceNumber(e.target.value);
        invoiceNumberLive = e.target.value;
      break;
      case "invoiceTerms":
        setInvoiceTerms(e.target.value);
        invoiceTermsLive = e.target.value;
        break;
      case "invoicePONumber":
        setInvoicePONumber(e.target.value);
        invoicePONumberLive = e.target.value;
        break;
    }

    checkForChanges();
  };



  const updateDate = (id, epoch)=> {

    switch(id) {
      case "invoiceDueDate":
        setInvoiceDueDate(epoch);
        invoiceDueDateLive = epoch;
        break;
      case "invoiceDateCreated":
        setInvoiceDateCreated(epoch);
        invoiceDateCreatedLive = epoch;
        break;

    }

    checkForChanges();
  };


  const sigCanvas = {}

  const clear = () => {
    this.sigCanvas.clear()
  }

  const handleClick = (id) => {

    switch(id) {
      case "save":
        
        break;
      case "clear":
        this.clear()

        // code block
    }

  };


  return (
    <>

<GeneralViewContainer maxWidth="lg">
      <Grid container spacing={1}>
      <Grid item xs={12}>
      
      <div style={{ width: '100%' }}>
      <Box display="flex" justifyContent="center" m={1} p={1}>
        <Box className={classes.signatureBoxInner} >
          <Paper square={true} elevation={4}>
      <SignatureCanvas penColor='black' ref={(ref) => { this.sigCanvas = ref }}
    canvasProps={{width: ((width<500)? (width-width/10): (width-width/4)), height: (height-height/3), className: 'sigCanvas'}} />
    </Paper>
    </Box>
      </Box>
      </div>

{/* <SignatureApp/> */}
      </Grid>
      <Grid item xs={6}>
      <Button id="save" onClick={handleClick} fullWidth variant="contained" color="primary">
        SAVE
      </Button>
      </Grid>
      <Grid item xs={6}>
      <Button id="clear" onClick={handleClick} fullWidth variant="contained" color="primary">
        CLEAR
      </Button>
      </Grid>
    </Grid>
    </GeneralViewContainer>

    </>
  )
}
